export const COUNTIES = [
	"Nairobi",
	"Mombasa",
	"Kwale",
	"Kilifi",
	"Tana River",
	"Lamu",
	"Taita Taveta",
	"Garissa",
	"Wajir",
	"Mandera",
	"Marsabit",
	"Isiolo",
	"Meru",
	"Tharaka - Nithi",
	"Embu",
	"Kitui",
	"Machakos",
	"Nyandarua",
	"Nyeri",
	"Kirinyaga",
	"Murang'a",
	"Kiambu",
	"Turkana",
	"West Pokot",
	"Samburu",
	"Uasin Gishu",
	"Elegeyo-Marakwet",
	"Nandi",
	"Baringo",
	"Laikipia",
	"Nakuru",
	"Narok",
	"Kajiado",
	"Makueni",
	"Kericho",
	"Kakamega",
	"Vihiga",
	"Bungoma",
	"Busia",
	"Siaya",
	"Homa Bay",
	"Migori",
	"Kisii",
	"Bomet",
	"Nyamira",
	"Kisumu",
	"Trans Nzoia",
];

export const REGION_INDEX_TO_COUNTY_INDEX = [
    [0], [1], [2], [3], [4], [5], [6], [7], [8], [9], [10], [11], [12], [13], [14], [15], [16], [17], [18], [19],
    [20], [21], [22], [23], [24], [25], [26], [27], [28], [29], [30], [31], [32], [33], [34], [35], [36], [37],
    [38], [39], [40], [41], [42], [43], [44], [45], [46],
];

// 0x1: Nairobi 0
// 0x2: Southwest 1
// 0x4: North/East 2

export const KENYA_REGIONS_BITFLAG = [
    0x1, // NAIROBI
    0x4, // MOMBASA
    0x4, // KWALE
    0x4, // KILIFI
    0x4, // TANA RIVER
    0x4, // LAMU
    0x4, // TAITA TAVETA
    0x4, // GARISSA
    0x4, // WAJIR
    0x4, // MANDERA
    0x4, // MARSABIT
    0x4, // ISIOLO
    0x1, // MERU
    0x1, // THARAKA - NITHI
    0x1, // EMBU
    0x4, // KITUI
    0x1, // MACHAKOS
    0x1, // NYANDARUA
    0x1, // NYERI
    0x1, // KIRINYAGA
    0x1, // MURANG'A
    0x1, // KIAMBU
    0x4, // TURKANA
    0x4, // WEST POKOT
    0x4, // SAMBURU
    0x2, // UASIN GISHU
    0x2, // ELGEYO-MARAKWET
    0x2, // NANDI
    0x2, // BARINGO
    0x1, // LAIKIPIA
    0x2, // NAKURU
    0x2, // NAROK
    0x1, // KAJIADO
    0x4, // MAKUENI
    0x2, // KERICHO
    0x2, // KAKAMEGA
    0x2, // VIHIGA
    0x2, // BUNGOMA
    0x2, // BUSIA
    0x2, // SIAYA
    0x2, // HOMA BAY
    0x2, // MIGORI
    0x2, // KISII
    0x2, // BOMET
    0x2, // NYAMIRA
    0x2, // KISUMU
    0x2, // TRANS NZOIA
];
